import routes from '@/constants/routes';
import { Button, ButtonGroup } from '@mui/material';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

const tabs = [
    {
        label: 'Publicados',
        value: 'publicados',
    },
    {
        label: 'Borradores',
        value: 'borradores',
    },
    {
        label: 'Archivados',
        value: 'archivados',
    },
];

type Params = {
    organizationId: string;
    contentStatus: string;
};

const StatusFilters = () => {
    const navigate = useNavigate();
    const { organizationId, contentStatus } = useParams<Params>();

    const handleChange = (value: string) => {
        if (organizationId) {
            navigate(
                generatePath(routes.organizations.content.main, {
                    organizationId,
                    contentStatus: value,
                })
            );
        }
    };

    return (
        <ButtonGroup variant="outlined" aria-label="Status filter button group">
            {tabs.map((tab) => (
                <Button
                    key={tab.value}
                    variant={contentStatus === tab.value ? "contained" : "outlined"}
                    onClick={() => handleChange(tab.value)}
                >
                    {tab.label}
                </Button>
            ))}
        </ButtonGroup>
    );
};

export default StatusFilters;
